import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';

import AuthReducer from './AuthReducer';
import EntitiesReducer from './entities';
import LoaderReducer from './LoaderReducer';
import ModalsReducer from './ModalsReducer';

export default combineReducers({
  auth: AuthReducer,
  entities: EntitiesReducer,
  loader: LoaderReducer,
  modals: ModalsReducer,
  form: reduxFormReducer,
  routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js